<template>
  <div class="container">
    <h1 style="text-align:center;">קליטת עובד קבלן</h1>
    <div class="warpper">
      <div class="field">
        <p>שם פרטי</p>
        <InputText
          v-model="values.firstName"
          type="text"
          placeholder="שם פרטי בעברית בלבד"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>שם משפחה</p>
        <InputText
          v-model="values.lastName"
          type="text"
          placeholder="שם משפחה בעברית בלבד"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>תעודת זהות/דרכון</p>
        <InputText
          v-model="values.idOrPassport"
          type="text"
          placeholder="ת.ז. (9 ספרות) או דרכון"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>תאריך לידה</p>
        <IlDateInput v-model="values.birthDate" />
        <small class="date-hint" v-if="values.birthDate">{{ format_date_il(values.birthDate) }}</small>
      </div>
      <div class="field">
        <p>נייד</p>
        <InputText
          v-model="values.mobile"
          type="text"
          placeholder="05XXXXXXXX"
          style="width:100%"
          maxlength="10"
        />
      </div>
      <div class="field">
        <p>תפקיד מיועד</p>
        <Dropdown
          v-model="values.role"
          :options="roleOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="נא לבחור תפקיד"
          style="width:100%"
          filter
        />
      </div>
      <div class="field">
        <p>שיוך לסניף</p>
        <Dropdown
          v-model="values.branch"
          :options="branchesOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="נא לבחור סניף"
          style="width:100%"
          :disabled="!branchesLoaded || branchesOptions.length === 0"
          filter
        />
        <small v-if="branchesOptions.length === 0 && branchesLoaded" style="color: red;">
          לא נמצאו סניפים
        </small>
      </div>
      <div class="field">
        <p>תאריך תחילת עבודה</p>
        <IlDateInput v-model="values.startDate" />
        <small class="date-hint" v-if="values.startDate">{{ format_date_il(values.startDate) }}</small>
      </div>
      <div class="field">
        <p>שם חברת הקבלן</p>
        <Dropdown
          v-model="values.contractorCompany"
          :options="companyOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="נא לבחור חברת קבלן"
          style="width:100%"
          :disabled="!companiesLoaded || companyOptions.length === 0"
          filter
        />
        <small v-if="companyOptions.length === 0 && companiesLoaded" style="color: red;">
          לא נמצאו חברות כוח אדם
        </small>
      </div>
      <div class="field">
        <p>שם פותח/ת הבקשה</p>
        <InputText
          v-model="values.ownerName"
          type="text"
          placeholder="הזן/י את שמך"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>דוא"ל לעדכון התהליך</p>
        <InputText
          v-model="values.email"
          type="text"
          placeholder="דואל"
          style="width:100%"
        />
      </div>
      <div class="field">
        <p>צרף תעודת זהות/דרכון (חובה) - {{ values.uploadedDocuments.length }}/5 מסמכים</p>
        <Button
          v-if="!isPending"
          label="צירף תמונה/מסמך"
          class="p-button-secondary upload-btn"
          :disabled="values.uploadedDocuments.length >= 5"
          @click="handleUpload"
        />
        <Button
          v-if="isPending"
          label="ממתין להעלאה..."
          class="p-button-secondary upload-btn"
          disabled
        />
        <input
          v-show="false"
          id="upload-image"
          type="file"
          accept="image/png,image/jpeg,image/jpg,image/heic,application/pdf"
          @change="handleChange"
        />
        <div v-if="fileError" style="color:red; margin-top: 5px;">{{ fileError }}</div>
      </div>
      <div class="field">
        <div class="images">
          <template
            v-for="document in values.uploadedDocuments"
            :key="document.filePath"
          >
            <div class="image">
              <img
                v-if="document.type != 'application/pdf'"
                :src="document.url"
                @click="handleOpenPdf(document)"
              />
              <img
                v-if="document.type == 'application/pdf'"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png"
                @click="handleOpenPdf(document)"
              />
              <div class="delete-bar" @click="delete_file(document)">
                <p>מחק</p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <Button
      label="שלח"
      class="p-button-help send-btn"
      :disabled="!companiesLoaded || companyOptions.length === 0 || !branchesLoaded || branchesOptions.length === 0"
      @click="handleSubmit"
    />
  </div>

  <!-- JUST FOR MAIL -->
  <div class="form-email" id="form-email" v-show="false">
    <table
      style="width:50%; border-collapse: collapse; font-size: 1.1rem; margin: 1rem 0;"
    >
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תאריך הבקשה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ format_date_il(values.createdAt) }},{{ format_time_il(values.createdAt, true) }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding:8px;">
          שם הסניף השולח
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding:8px;">
          {{ values.branche }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          סוג הבקשה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.type }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שם פרטי
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.firstName }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שם משפחה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.lastName }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תעודת זהות/דרכון
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.idOrPassport }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תאריך לידה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ format_date_il(values.birthDate) }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          נייד
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.mobile }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תפקיד מיועד
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.role }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שיוך לסניף
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.branch }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          תאריך תחילת עבודה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ format_date_il(values.startDate) }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שם חברת הקבלן
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.contractorCompany }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          שם פותח הבקשה
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.ownerName }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          אימייל לעדכון סטטוס וקבלת עדכונים
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.email }}
        </td>
      </tr>
      <tr style="background-color: #dddddd;">
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          מספר מסמכים מצורפים
        </th>
        <td style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          {{ values.uploadedDocuments.length }}
        </td>
      </tr>
      <tr>
        <th style="border:1px solid #dddddd; text-align:right; padding: 8px;">
          סטטוס
        </th>
        <td
          style="border:1px solid #dddddd; text-align:right; padding: 8px; color:green"
        >
          {{ values.status }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import swal from "sweetalert";
import {projectFirestore, projectFunctions} from '../../../../../firebase/config'
import {increment} from '@/Methods/office_request_funcs'
import use_office_requests_storage from '@/Methods/use_office_requests_storage'
import { onMounted, ref } from "vue";
import store from '../../../../../store';
import { format_date_il, format_time_il } from '@/Methods/Dates'
import IlDateInput from '@/components/Applications/officeRequests/components/inputs/IlDateInput.vue'

export default {
  components: { IlDateInput, InputText, Dropdown },
  props: ['docId'],

  setup(props) {
    const branchesOptions = ref([]);
    const branchesLoaded = ref(false);

    const roleOptions = ref([
      { label: "מעדנייה", value: "מעדנייה" },
      { label: "קצבייה", value: "קצבייה" },
      { label: "סדרנות", value: "סדרנות" },
      { label: "קופה", value: "קופה" },
      { label: "מחסן", value: "מחסן" },
      { label: "ירקות", value: "ירקות" },
      { label: "ניקיון", value: "ניקיון" },
      { label: "שמירה", value: "שמירה" },
      { label: "פקידות", value: "פקידות" }
    ]);

    const companyOptions = ref([]);
    const companiesLoaded = ref(false);

    const { url, filePath, uploadImage, deleteImage } = use_office_requests_storage();
    const isPending = ref(false);
    const file = ref(null);
    const fileError = ref(null);
    const error = ref("");

    const values = ref({
      firstName: "",
      lastName: "",
      fullName: "",
      idNumber: "",
      idOrPassport: "",
      birthDate: "",
      mobile: "",
      role: "",
      branch: "",
      startDate: "",
      contractorCompany: "",
      ownerName: "",
      email: "",
      branche: "",
      charge: "לא הוגדר",
      type: "קליטת עובד קבלן",
      status: "חדש",
      createdAt: new Date(),
      uploadedDocuments: []
    });

    // Upload handlers
    const handleUpload = () => {
      document.getElementById("upload-image").click();
    };

    const handleOpenPdf = document => {
      window.open(document.url, "_blank");
    };

    const delete_file = async document => {
      const index = values.value.uploadedDocuments.findIndex(
        doc => doc.filePath === document.filePath
      );
      values.value.uploadedDocuments.splice(index, 1);
      await deleteImage(document.filePath);
    };

    const handleChange = async e => {
      isPending.value = true;
      const types = ["image/png", "image/jpeg", "image/jpg", "image/heic", "application/pdf"];
      const selected = e.target.files[0];

      if (selected && types.includes(selected.type)) {
        file.value = selected;
        fileError.value = null;
        if (values.value.uploadedDocuments.length < 5) {
          await uploadImage(file.value, "Contractor_Employee");
          values.value.uploadedDocuments.push({
            url: url.value,
            filePath: filePath.value,
            type: selected.type
          });
        }
      } else {
        console.log("error");
        file.value = null;
        fileError.value = "סוג קובץ זה אינו נתמך, נא להעלות JPG, PNG, HEIC או PDF בלבד!";
      }
      isPending.value = false;
      // Reset input so same file can be selected again
      e.target.value = '';
    };

    // Validation functions
    const validateHebrewName = (name) => {
      const hebrewRegex = /^[\u0590-\u05FF\s]+$/;
      return hebrewRegex.test(name) && name.length >= 2 && name.length <= 30;
    };

    const validateIsraeliID = (id) => {
      if (!/^\d{9}$/.test(id)) return false;

      // Israeli ID checksum validation (Luhn algorithm variant)
      let sum = 0;
      for (let i = 0; i < 9; i++) {
        let digit = parseInt(id[i]);
        let step = (i % 2) + 1;
        let result = digit * step;
        if (result > 9) result -= 9;
        sum += result;
      }
      return sum % 10 === 0;
    };

    const validatePassport = (passport) => {
      // Passport: Latin letters + digits, 8-9 characters
      const passportRegex = /^[A-Za-z0-9]{8,9}$/;
      return passportRegex.test(passport);
    };

    const validateIdOrPassport = (value) => {
      // Accept 8-9 alphanumeric characters (letters or numbers)
      const regex = /^[A-Za-z0-9]{8,9}$/;
      return regex.test(value);
    };

    const calculateAge = (birthDate) => {
      if (!birthDate || birthDate === "") return 0;
      const today = new Date();
      const birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    };

    const validateMobile = (mobile) => {
      // Must be exactly 10 digits starting with 05
      return /^05\d{8}$/.test(mobile);
    };

    const validateStartDate = (startDate) => {
      return startDate && startDate !== "";
    };

    const validation = () => {
      // First name validation
      if (!values.value.firstName || !validateHebrewName(values.value.firstName)) {
        error.value = "נא למלא שם פרטי בעברית בלבד (2-30 תווים)";
        return false;
      }

      // Last name validation
      if (!values.value.lastName || !validateHebrewName(values.value.lastName)) {
        error.value = "נא למלא שם משפחה בעברית בלבד (2-30 תווים)";
        return false;
      }

      // ID or Passport validation
      if (!values.value.idOrPassport || !validateIdOrPassport(values.value.idOrPassport)) {
        error.value = "נא למלא תעודת זהות תקינה (9 ספרות) או דרכון תקין (8-9 תווים)";
        return false;
      }

      // Birth date and age validation
      if (!values.value.birthDate || values.value.birthDate === "") {
        error.value = "נא לבחור תאריך לידה";
        return false;
      }
      const age = calculateAge(values.value.birthDate);
      if (age < 16 || age > 80) {
        error.value = "גיל העובד חייב להיות בין 16 ל-80";
        return false;
      }

      // Mobile validation
      if (!validateMobile(values.value.mobile)) {
        error.value = "נא למלא מספר נייד תקין (10 ספרות המתחיל ב-05)";
        return false;
      }

      // Role validation
      if (!values.value.role || values.value.role.length === 0) {
        error.value = "עליך לבחור תפקיד מיועד";
        return false;
      }

      // Branch validation
      if (!values.value.branch || values.value.branch.length === 0) {
        error.value = "עליך לבחור שיוך לסניף";
        return false;
      }

      // Start date validation
      if (!validateStartDate(values.value.startDate)) {
        error.value = "נא לבחור תאריך תחילת עבודה";
        return false;
      }

      // Contractor company validation
      if (!values.value.contractorCompany || values.value.contractorCompany.length < 2 || values.value.contractorCompany.length > 60) {
        error.value = "נא למלא שם חברת קבלן (2-60 תווים)";
        return false;
      }

      // Owner name validation
      if (!values.value.ownerName || values.value.ownerName.length < 1) {
        error.value = "נא למלא את שם פותח הבקשה";
        return false;
      }

      // Email validation
      if (!values.value.email || values.value.email.length === 0 || !values.value.email.includes("@")) {
        error.value = "נא למלא כתובת מייל תקינה";
        return false;
      }

      // Uploaded documents validation (required)
      if (!values.value.uploadedDocuments || values.value.uploadedDocuments.length === 0) {
        error.value = "נא לצרף לפחות מסמך אחד של תעודת זהות או דרכון";
        return false;
      }

      return true;
    };

    const fetchCompanies = async () => {
      try {
        const snapshot = await projectFirestore
          .collection('Shivuk')
          .doc('Shivuk')
          .collection('Hr_Companies')
          .get();

        companyOptions.value = snapshot.docs.map(doc => ({
          label: doc.data().name,
          value: doc.data().name
        }));
        companiesLoaded.value = true;
      } catch (err) {
        console.error('Error fetching companies:', err);
        companyOptions.value = [];
        companiesLoaded.value = true;
      }
    };

    const fetchBranches = async () => {
      try {
        const snapshot = await projectFirestore
          .collection('Shivuk')
          .doc('Shivuk')
          .collection('Branches')
          .get();

        branchesOptions.value = snapshot.docs.map(doc => ({
          label: doc.data().name,
          value: doc.data().name
        }));
        branchesLoaded.value = true;
      } catch (err) {
        console.error('Error fetching branches:', err);
        branchesOptions.value = [];
        branchesLoaded.value = true;
      }
    };

    const handleSubmit = async () => {
      if (!validation()) {
        swal("בעיה", `${error.value}`, "warning");
      } else {
        try {
          // Combine first and last name for fullName and idNumber
          values.value.fullName = `${values.value.firstName} ${values.value.lastName}`;
          values.value.idNumber = values.value.idOrPassport;

          const doc = projectFirestore
            .collection('Applications')
            .doc(props.docId)
            .collection('Contractor_Employee')
            .doc();

          await doc.set({ ...values.value, id: doc.id });
          await increment(props.docId);
          sendEmailToUser();
          sendEmailToCharge();
          clearData();
          swal("הצלחה", "הטופס נשלח בהצלחה", "success");
        } catch (err) {
          console.error(err);
          swal("שגיאה", "אירעה שגיאה בשליחת הטופס", "error");
        }
      }
    };

    function sendEmailToUser() {
      projectFunctions.httpsCallable('send_email')({
        html: `<div>
                <h3>
                    שלום ${values.value.ownerName},
                </h3>
                <h3>
                    בקשתך לקליטת עובד קבלן: ${values.value.firstName} ${values.value.lastName}
                </h3>
                <h3>
                    עבור: ${values.value.type}
                </h3>
                <h3>
                    לסניף/אתר ${values.value.branche}
                </h3>
                <h3>
                    נשלחה לטיפול!
                </h3>
                <h3 style="color:red;">
                    נא לשים לב להמשך עדכונים שיתקבלו אוטמטית מהמערכת בכל שלבי הטיפול!
                </h3>
            </div>`,
        destinations: [`${values.value.email}`],
        from: "מערכת לבקשות משרדיות",
        title: "נפתחה בקשה משרדית חדשה",
        attachments: values.value.uploadedDocuments.map((doc, index) => ({
          filename: `תעודת_זהות_${values.value.firstName}_${values.value.lastName}_${index + 1}.${doc.type === 'application/pdf' ? 'pdf' : doc.type.split('/')[1]}`,
          path: doc.url
        }))
      });
    }

    function sendEmailToCharge() {
      projectFunctions.httpsCallable('send_email')({
        html: document.getElementById("form-email").innerHTML,
        destinations: ["rosman.mate@gmail.com", "ravit@rosman.co.il"],
        from: "מערכת לבקשות משרדיות",
        title: "נפתחה בקשה משרדית חדשה - קליטת עובד קבלן",
        attachments: values.value.uploadedDocuments.map((doc, index) => ({
          filename: `תעודת_זהות_${values.value.firstName}_${values.value.lastName}_${index + 1}.${doc.type === 'application/pdf' ? 'pdf' : doc.type.split('/')[1]}`,
          path: doc.url
        }))
      });
    }

    const clearData = () => {
      const temp = {
        firstName: "",
        lastName: "",
        fullName: "",
        idNumber: "",
        idOrPassport: "",
        birthDate: "",
        mobile: "",
        role: "",
        branch: "",
        startDate: "",
        contractorCompany: "",
        ownerName: "",
        email: values.value.email,
        branche: values.value.branche,
        charge: "לא הוגדר",
        type: "קליטת עובד קבלן",
        status: "חדש",
        createdAt: new Date(),
        uploadedDocuments: []
      };
      values.value = temp;
    };

    onMounted(() => {
      fetchCompanies();
      fetchBranches();

      setTimeout(() => {
        if (store.getters.user.branche) {
          values.value.branche = store.getters.user.branche;
        } else {
          values.value.branche = store.getters.user.display_name;
        }
        values.value.email = store.getters.user.email;
      }, 1000);
    });

    return {
      format_date_il,
      format_time_il,
      values,
      error,
      handleSubmit,
      branchesOptions,
      branchesLoaded,
      roleOptions,
      companyOptions,
      companiesLoaded,
      isPending,
      fileError,
      handleUpload,
      handleChange,
      handleOpenPdf,
      delete_file
    };
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.warpper {
  width: 50%;
  height: calc(100% - 100px);
  border: 1px solid black;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding-bottom: 20px;
}
.field {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
  margin-top: 15px;
}
.field p {
  font-size: 1.1rem;
  margin-bottom: 5px;
}
.send-btn {
  margin-top: 15px;
  width: 50%;
}
.upload-btn {
  width: 30%;
}
.images {
  width: 100%;
  height: max-content;
  max-height: max-content;
  min-height: 100px;
  padding: 3px;
  display: flex;
  margin-top: 5px;
  overflow-x: auto;
  flex-wrap: wrap;
}
.images .image {
  position: relative;
  width: calc(100% / 3 - 10px);
  min-width: 150px;
  height: 200px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
}
.images .image .delete-bar {
  margin-top: 10px;
  width: 100%;
  height: 30px;
  background-color: rgb(145, 3, 3);
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border-radius: 5px;
}
.images .image img {
  max-width: 100%;
  max-height: calc(100% - 40px);
  border-radius: 5px;
  object-fit: contain;
}

@media screen and (max-width: 600px) {
  .container {
    justify-content: unset;
    overflow: hidden;
    background: var(--secondary);
    color: #fff;
  }
  .warpper {
    width: 100%;
    border: none;
    overflow-y: auto;
    flex-shrink: 0;
  }
  .send-btn {
    width: 100%;
  }
  .upload-btn {
    width: 100%;
  }
}
</style>
